import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CaseDetailV2 } from '../common-structures/case-detail';

@Component({
    selector: 'app-app-contact-card',
    templateUrl: './app-contact-card.component.html',
    styleUrls: ['./app-contact-card.component.scss'],
    standalone: false
})
export class AppContactCardComponent implements OnInit {
	caseDetail: CaseDetailV2;
	type: string;
	name: string;
	phone: string;
	email: string;

	constructor(
		public dialogRef: MatDialogRef<AppContactCardComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private snackBar: MatSnackBar
	) {}

	ngOnInit(): void {
		this.caseDetail = this.data.caseDetail;
		this.type = this.data.type;
		if (this.isTypeCp()) {
			this.name = this.caseDetail?.cpFirstName + ' ' + this.caseDetail?.cpLastName;
			this.phone = this.caseDetail?.cpCellNumber;
			this.email = this.caseDetail?.cpEmailAddress;
		} else {
			this.name = this.caseDetail?.rspName;
			this.phone = this.caseDetail?.rspPhone;
			this.email = this.caseDetail?.rspEmailAddress;
		}
	}

	isTypeCp(): boolean {
		return this.type === 'CP';
	}

	public copyToClipboard(text) {
		var dummy = document.createElement('textarea');
		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
		this.openSnackBar();
	}

	private openSnackBar() {
		this.snackBar.open('Copied!', 'OK', {
			duration: 1000,
		});
	}
}
